import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Colors from 'ui-library/Colors';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';

interface LLMLoadingMessageProps {
  text: string;
  fontSize?: number;
}

export default function LLMLoadingMessage(props: LLMLoadingMessageProps): JSX.Element {
  return (
    <div
      className={css(styles.loadingContainer)}
      data-test-component="LLMLoadingMessage"
      data-test-element="root"
    >
      <BenchlingDuotoneIcon
        icon="spinner-third"
        primaryColor={Colors.PURPLE_DARK}
        secondaryColor={Colors.PURPLE_LIGHTER}
        spin={true}
      />
      <span
        className={css(styles.loadingShimmer)}
        // These need to be defined inline to avoid Aphrodite slapping a !important on this
        // and thus ruining the animation
        style={{
          background: `linear-gradient(120deg, ${Colors.GRAY_DARKER} 0%, ${Colors.GRAY_DARK} 20%, ${Colors.GRAY_LIGHT} 40%, ${Colors.GRAY_DARK} 60%, ${Colors.GRAY_DARKER} 80%) 0 0 / 200% 100%`,
          backgroundClip: 'text',
          backgroundSize: '200% 100%',
          WebkitBackgroundClip: 'text',
          fontSize: props.fontSize,
        }}
        data-test-component="SQLAssistantModal"
        data-test-element="loadingBlurb"
      >
        {props.text}
      </span>
    </div>
  );
}

const keyframes = {
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
};

const styles = StyleSheet.create({
  loadingContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
  },
  loadingShimmer: {
    animationName: [keyframes],
    animationDelay: '0s',
    animationDuration: '3s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    color: 'transparent',
    display: 'inline-block',
    WebkitTextFillColor: 'transparent',
  },
});
